import { render, staticRenderFns } from "./TutorSendMails.vue?vue&type=template&id=5ce50a72"
import script from "./TutorSendMails.vue?vue&type=script&lang=ts"
export * from "./TutorSendMails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports